import { Outlet } from "react-router-dom";
import VistaMovil from "../components/vistaMovil";

const Layout = () => {
  return (
    <>
            <Outlet />
            <VistaMovil />
    </>
  )
};

export default Layout;